import { Card,CardContent,Grid,CardActionArea,Box,Container } from "@mui/material";
import { Link } from "react-router-dom";
import { signUpData } from "./signUpMockData";
import Logo from "../../../assets/images/signin/logoDark.png";
import { useMediaQuery } from "@mui/material";
import { v4 as uuidv4 } from 'uuid';


const SignUpCard = () => {
  const isResponsive = useMediaQuery("(max-width:300px)");
  return (
    <Box sx={{ bgcolor: "#f0f3fb", py: "40px" }}>
      <Container>
        <Box textAlign="center">
          <img
            src={Logo}
            alt="logo"
            style={{ width: isResponsive ? "100%" : "" }}
          />
          <p className="fs-40 fw-500 grey-color" style={{ padding: "30px 0" }}>
            Select the user type to Sign up
          </p>
        </Box>
        <Grid
          container
          spacing={10}
          sx={{ justifyContent: { md: "center", xs: "center" } }}
        >
          {signUpData?.map((card: any, index: number) => (
            <Grid
              item
              xs={12}
              lg={4}
              md={4}
              sm={6}
              sx={{
                display: "flex",
                justifyContent: { md: "center", xs: "center" },
              }}
              key={uuidv4()}
            >
              <Link
                to={`${card.path}/${card.title}`}
                style={{ textDecoration: "none", width: "100%" }}
              >
                <Card
                  className="card-hover-color cursor-pointer"
                  sx={{
                    boxShadow: "none",
                    borderRadius: "6px",
                    "&:hover": {
                      transition: "0.3s",
                      outline: "1.5px solid #ffc816",
                      boxShadow: "0px 1px 1px -1px",
                    },
                  }}
                >
                  <CardActionArea
                    disableRipple
                    sx={{
                      display: "flex",
                      color: "#212121",
                      pt: 4,
                      justifyContent: "center",
                      flexDirection: "column",
                      borderRadius: "6px",
                    }}
                  >
                    <img className="imgcolor" src={card.icon} alt="icon" />
                    <CardContent sx={{ display: "block", textAlign: "center" }}>
                      <p
                        className="fs-20 fw-500 grey-color"
                        style={{ margin: "0px" }}
                      >
                        {card.title}
                      </p>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
export default SignUpCard;
